import { CustomTextField } from 'esocial.web.react.lib/cjs/components/form/Custom/CustomTextField';
import ListaRegraValidacao from 'esocial.web.react.lib/cjs/components/form/Validation/ListaRegraValidacao';
import RegraDiaMesAno from 'esocial.web.react.lib/cjs/components/form/Validation/RegraDiaMesAno';
import RegraObrigatoriedade from 'esocial.web.react.lib/cjs/components/form/Validation/RegraObrigatoriedade';
import { VepDatePicker } from 'esocial.web.react.lib/cjs/components/form/Vep/VepDatePicker';
import { VepTextField } from 'esocial.web.react.lib/cjs/components/form/Vep/VepTextField';
import { Display } from 'esocial.web.react.lib/cjs/components/util/Display';
import { Fieldset } from 'esocial.web.react.lib/cjs/components/util/Fieldset';
import { Mascara } from 'esocial.web.react.lib/cjs/utils/enums';
import { verificarTodosComponentesTocados } from 'esocial.web.react.lib/cjs/utils/geral';
import { Fragment, useEffect, useState } from 'react';
import AgentesNocivos from './AgentesNocivos';
import AmbientesTrabalho from './AmbientesTrabalho';
import ResponsaveisRegistro from './ResponsaveisRegistro';

function ExposicaoRiscov_S_01_01_00Consulta(props) {
    // Estado de campos ainda não tocados pelo usuário e formulário ainda não submetido (usado no mecanismo de validações)
    const objetoComponentesTocados = {};

    objetoComponentesTocados['dataInicioCondicao'] = false;
    objetoComponentesTocados['dataFimCondicao'] = false;
    objetoComponentesTocados['descricaoAtividade'] = false;

    const [componenteTocadoFormulario, setComponenteTocadoFormulario] = useState(objetoComponentesTocados);

    // Construção das regras de validação para os campos do formulário
    const [regraValidacaoFormulario, setRegraValidacaoFormulario] = useState({});
    const [obrigatoriedadeDataFimCondicao, setObrigatoriedadeDataFimCondicao] = useState(true);

    useEffect(() => {
        const objetoRegrasValidacao = {};

        // 16/01/2023
        const dataInicioCondicaoValidacaoDataFimCondicao = new Date(2023, 0, 16);

        if (props.modelo != null) {
            setObrigatoriedadeDataFimCondicao(props.modelo.codCategoria.startsWith('2') && new Date(props.modelo.dataInicioCondicao.valor) >= dataInicioCondicaoValidacaoDataFimCondicao);
            objetoRegrasValidacao['dataInicioCondicao'] = new ListaRegraValidacao([new RegraObrigatoriedade(props.modelo.dataInicioCondicao.valor), new RegraDiaMesAno(props.modelo.dataInicioCondicao.valor)], componenteTocadoFormulario['dataInicioCondicao']);
            objetoRegrasValidacao['dataFimCondicao'] = new ListaRegraValidacao([new RegraObrigatoriedade(props.modelo.dataFimCondicao.valor), new RegraDiaMesAno(props.modelo.dataInicioCondicao.valor)], componenteTocadoFormulario['dataFimCondicao'] && obrigatoriedadeDataFimCondicao);
            objetoRegrasValidacao['descricaoAtividade'] = new RegraObrigatoriedade(props.modelo.descricaoAtividade.valor, componenteTocadoFormulario['descricaoAtividade']);
            objetoRegrasValidacao.todosComponentesTocados = verificarTodosComponentesTocados(componenteTocadoFormulario);
        }

        setRegraValidacaoFormulario(objetoRegrasValidacao);
    }, [props.modelo, componenteTocadoFormulario]);

    return (
        (props.modelo !== null && Object.values(regraValidacaoFormulario).length > 0) &&
        <Fragment>
            <Fieldset legend="Identificação do Trabalhador" spacing={4}>
                <VepTextField
                    accessor="cpfTrabalhador"
                    label="CPF"
                    model={props.modelo}
                    xs={12} md={3}
                    readOnly
                    maskPattern={Mascara.CPF}
                />

                <CustomTextField
                    xs={12} md={6}
                    label="Nome"
                    value={props.modelo.nome}
                    readOnly />

                <VepTextField
                    accessor="matricula"
                    label="Matrícula"
                    model={props.modelo}
                    xs={12} md={3}
                    readOnly
                />
            </Fieldset>

            <Fieldset legend="Inicio" spacing={4}>
                <VepDatePicker
                    accessor="dataInicioCondicao"
                    label="Quando o trabalhador iniciou as atividades nas condições de exposição?"
                    model={props.modelo}
                    setModel={props.setModelo}
                    xs={12} md={6}
                    readOnly={props.visualizacao}
                    {...regraValidacaoFormulario['dataInicioCondicao'].obterPropriedadesValidacao()}
                    onBlur={() => setComponenteTocadoFormulario({ ...componenteTocadoFormulario, 'dataInicioCondicao': true })}
                />

                <Display show={obrigatoriedadeDataFimCondicao}>
                    <VepDatePicker
                        accessor="dataFimCondicao"
                        required={obrigatoriedadeDataFimCondicao}
                        label="Quando o trabalhador terminou as atividades nas condições de exposição?"
                        model={props.modelo}
                        setModel={props.setModelo}
                        xs={12} md={6}
                        readOnly={props.visualizacao}
                        {...regraValidacaoFormulario['dataFimCondicao'].obterPropriedadesValidacao()}
                        onBlur={() => setComponenteTocadoFormulario({ ...componenteTocadoFormulario, 'dataFimCondicao': true })}
                    />
                </Display>
            </Fieldset>

            {/* Detail de ambientes de trabalho*/}
            <AmbientesTrabalho modelo={props.modelo} setModelo={props.setModelo} somenteVisualizacao={props.visualizacao}></AmbientesTrabalho>
            {/* fim Detail de agentes nocivos*/}

            <VepTextField
                accessor="descricaoAtividade"
                label="Descrição das atividades físicas ou mentais, realizadas pelo trabalhador"
                model={props.modelo}
                setModel={props.setModelo}
                xs={12} md={12}
                multiline
                rows={4}
                required
                readOnly={props.visualizacao}
                {...regraValidacaoFormulario['descricaoAtividade'].obterPropriedadesValidacao()}
                onBlur={() => setComponenteTocadoFormulario({ ...componenteTocadoFormulario, 'descricaoAtividade': true })}
            />

            {/* Detail de agentes nocivos*/}
            <AgentesNocivos modelo={props.modelo} setModelo={props.setModelo} somenteVisualizacao={props.visualizacao}></AgentesNocivos>
            {/* fim Detail de agentes nocivos*/}

            {/* Detail de responsaveis registro*/}
            <ResponsaveisRegistro modelo={props.modelo} setModelo={props.setModelo} somenteVisualizacao={props.visualizacao}></ResponsaveisRegistro>
            {/* fim Detail de responsaveis*/}

            <VepTextField
                accessor="observacaoComplementar"
                label="Há alguma observação complementar referente a registros ambientais?"
                model={props.modelo}
                setModel={props.setModelo}
                xs={12} md={12}
                multiline
                rows={4}
                readOnly={props.visualizacao}
                required={false}
            />
        </Fragment >
    );
}

export default ExposicaoRiscov_S_01_01_00Consulta;
